<template>
  <div class="q-mt-md">
    <div class="row q-col-gutter-md">
      <div class="col-12 col-md-3">
        <q-list bordered class="rounded-borders">
          <q-item-label header>Сводка НДС</q-item-label>
          <q-item>
            <q-item-section>
              <q-item-label>НДС начисленный</q-item-label>
              <q-item-label caption>По исходящим документам</q-item-label>
            </q-item-section>
            <q-item-section side>{{ formatMoney(totals.output_vat ?? summary.none_nalog) }}</q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-item-label>НДС к вычету</q-item-label>
              <q-item-label caption>По входящим документам</q-item-label>
            </q-item-section>
            <q-item-section side>{{ formatMoney(totals.input_vat) }}</q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-item-label>НДС восстановленный</q-item-label>
              <q-item-label caption>Если показатель доступен</q-item-label>
            </q-item-section>
            <q-item-section side>{{ formatMoney(totals.restored_vat || '0') }}</q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-item-label>НДС к уплате</q-item-label>
              <q-item-label caption>Расчет</q-item-label>
            </q-item-section>
            <q-item-section side>
              <q-chip color="primary" text-color="white">{{ formatMoney(totals.payable || '0') }}</q-chip>
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-item-label>НДС к возмещению</q-item-label>
              <q-item-label caption>Расчет</q-item-label>
            </q-item-section>
            <q-item-section side>
              <q-chip color="positive" text-color="white">{{ formatMoney(totals.refund || '0') }}</q-chip>
            </q-item-section>
          </q-item>
        </q-list>
      </div>

      <div class="col-12 col-md-9">
        <q-list bordered separator>
          <q-item-label header>Разделы декларации</q-item-label>
          <q-item>
            <q-item-section>
              <q-item-label>Раздел 1 — сумма налога к уплате / возмещению</q-item-label>
              <q-item-label caption>Доступно в XML-экспорте</q-item-label>
            </q-item-section>
            <q-item-section side>{{ sectionStatus('1') }}</q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-item-label>Раздел 3 — расчет налога</q-item-label>
              <q-item-label caption>Налоговая база и итог НДС</q-item-label>
            </q-item-section>
            <q-item-section side>{{ sectionStatus('3') }}</q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-item-label>Раздел 8 — сведения из книги покупок</q-item-label>
              <q-item-label caption>{{ incomingCount }} входящих документов</q-item-label>
            </q-item-section>
            <q-item-section side>
              <q-chip color="info" text-color="white">{{ incomingCount }}</q-chip>
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-item-label>Раздел 9 — сведения из книги продаж</q-item-label>
              <q-item-label caption>{{ outgoingCount }} исходящих документов</q-item-label>
            </q-item-section>
            <q-item-section side>
              <q-chip color="info" text-color="white">{{ outgoingCount }}</q-chip>
            </q-item-section>
          </q-item>
          <q-item>
            <q-item-section>
              <q-item-label>Остальные разделы</q-item-label>
              <q-item-label caption>Не заполнено или недоступно для этого отчета</q-item-label>
            </q-item-section>
            <q-item-section side>
              <q-chip color="grey" text-color="white">Не поддерживается</q-chip>
            </q-item-section>
          </q-item>
        </q-list>
      </div>
    </div>
  </div>
</template>

<script>
import { formatMoney } from '../utils/reportFormatters'

export default {
  name: 'VatDeclarationView',
  props: {
    summary: {
      type: Object,
      default: () => ({})
    },
    sections: {
      type: Object,
      default: () => ({})
    },
    incomingCount: {
      type: Number,
      default: 0
    },
    outgoingCount: {
      type: Number,
      default: 0
    }
  },
  computed: {
    totals() {
      return this.summary.totals || {}
    }
  },
  methods: {
    formatMoney,
    sectionStatus(number) {
      const section = this.sections[number]
      if (!section) {
        return 'Не заполнено'
      }
      const labels = {
        filled: 'Заполнено',
        empty: 'Не заполнено',
        unsupported: 'Не поддерживается',
        partial: 'Частично'
      }
      return labels[section.status] || section.status || 'Заполнено'
    }
  }
}
</script>
